import React from 'react';
import { message, Tooltip, Typography } from 'antd';
import { VenueService } from 'services/SkyboxServices';
import { LoggerService } from 'sharedServices';

const ForceCompetitivePricingSync: React.FC<{ venueId: number }> = ({
  venueId,
}) => {
  const handleClick = async () => {
    try {
      await new VenueService().forceCompetitivePricingSync(venueId);
      message.success({
        content: 'Competitive pricing sync initiated',
        duration: 5,
        className: 'toastMsg savedSuccess',
      });
    } catch (error: any) {
      await new LoggerService().log({
        payload: error,
        function_name: 'forceCompetitivePricingSync',
      });
      message.error({
        content: 'Competitive pricing sync failed to initiate.',
        duration: 5,
        className: 'toastMsg savedFailed',
      });
    }
  };

  return (
    <Tooltip title="Force Sync Competitive Price" placement="left">
      <Typography.Link onClick={handleClick}>
        <i className="da icon-four-arrow-sync-blue" />
      </Typography.Link>
    </Tooltip>
  );
};

export default ForceCompetitivePricingSync;
